import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { heading5Obj } = typographyStyles;

export const responseWrapperCss = {
  display: "flex",
  alignItems: "center",
  position: "relative",
  marginBottom: "8px",
  width: "100%",
};

export const withTrackEventCss = {
  width: "100%",
};

export const responsePlaceholderCss = {
  "&::placeholder": {
    color: colors.ui.neutral[300],
    ...heading5Obj,
  },
};

export const errorTextHeight = {
  span: {
    height: "16px",
  },
};

export const trashButtonIconCss = {
  path: {
    stroke: colors.ui.neutral[400],
    strokeWidth: "3px",
  },
};
